import { render, staticRenderFns } from "./CampaignFooter.vue?vue&type=template&id=97eebeca&scoped=true&"
import script from "./CampaignFooter.vue?vue&type=script&lang=js&"
export * from "./CampaignFooter.vue?vue&type=script&lang=js&"
import style0 from "./CampaignFooter.vue?vue&type=style&index=0&id=97eebeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eebeca",
  null
  
)

export default component.exports